import { CostCentersConfigurationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useCostCenterConfiguration = () => {
  const { data, loading, refetch } = useQuery(CostCentersConfigurationsDocument)

  const configurations = data?.costCenters.configurationsConnection.nodes || []

  return {
    isLoading: loading,
    configurations,
    refetch,
  }
}
